import cImg1 from '../images/casestudy/1.png'
import cImg2 from '../images/casestudy/2.png'
import cImg3 from '../images/casestudy/3.png'
import cImg4 from '../images/casestudy/4.png'
import cImg5 from '../images/casestudy/5.png'
import cImg6 from '../images/casestudy/6.png'
import cImg7 from '../images/casestudy/7.png'
import cImg8 from '../images/casestudy/8.png'
import cImg9 from '../images/casestudy/9.png'
import cImg10 from '../images/casestudy/10.png'


const caseStudies = [
  { 
    id: 1, 
    category: "cat4", 
    img: cImg1, 
    title: "Odoo ERP Integration for Retail", 
    slug: "odoo-integration",
    mainTitle: "Centralizing retail operations with Odoo ERP",
    challenge: "A multi-store retail chain struggled with fragmented systems, manual inventory management across locations, delayed reporting, and no real-time visibility into sales and stock. Each store operated independently, leading to stock imbalances and missed sales opportunities.",
    approach: "We implemented a centralized Odoo ERP system integrating all store locations with real-time POS, inventory management, and financial modules. Connected all stores to a single database for unified reporting and automated stock synchronization.",
    result: "Inventory accuracy improved to 99%, stock-out incidents reduced by 80%, month-end reporting time cut from 5 days to 1 day, and revenue visibility improved decision-making.",
    requirements: [
      "Multi-store POS system setup",
      "Real-time inventory sync across locations",
      "Centralized financial reporting",
      "Customer data consolidation",
      "Stock reorder automation",
      "Staff training for all locations"
    ],
    outcomes: [
      "99% inventory accuracy across all stores",
      "80% reduction in stock-out incidents",
      "Month-end reporting reduced to 1 day",
      "Real-time sales visibility by store",
      "Improved customer loyalty tracking",
      "Easy expansion to new store locations"
    ],
    client: "Multi-Store Retail Chain",
    service: "Odoo POS & Inventory Management",
    date: "15-09-2024",
    location: "Mumbai, India"
  },

  { 
    id: 2, 
    category: "cat3", 
    img: cImg2, 
    title: "Shopify Store Setup & Customization", 
    slug: "shopify-development",
    mainTitle: "Building a high-converting Shopify storefront",
    challenge: "An e-commerce startup needed a fast, mobile-optimized storefront but lacked technical expertise. Their manual order processing caused delays, inventory mismatches, and poor customer experience.",
    approach: "We designed and launched a custom Shopify store with premium theme customization, integrated payment gateways, and connected inventory management. Optimized for mobile and SEO to drive organic traffic.",
    result: "Site conversion rate increased by 35%, average order value grew by 28%, page load time improved to <2 seconds, and order processing time reduced from 2 hours to 15 minutes.",
    requirements: [
      "Shopify store setup & premium theme",
      "Custom homepage & product pages",
      "Payment gateway integration",
      "Inventory management system",
      "SEO optimization",
      "Mobile responsiveness testing"
    ],
    outcomes: [
      "35% increase in conversion rate",
      "28% growth in average order value",
      "Page load time under 2 seconds",
      "Order processing automated",
      "Improved mobile experience",
      "100% uptime & reliability"
    ],
    client: "E-commerce Startup",
    service: "Shopify Store Development",
    date: "22-10-2024",
    location: "Bangalore, India"
  },

  { 
    id: 3, 
    category: "cat4", 
    img: cImg3, 
    title: "Odoo Manufacturing (MRP) Workflow Setup", 
    slug: "odoo-manufacturing",
    mainTitle: "Optimizing production with Odoo MRP system",
    challenge: "A manufacturing company faced production delays, material shortages, and poor visibility into work orders. Production planning relied on spreadsheets, causing inefficiencies and on-time delivery missed targets of 65%.",
    approach: "We implemented Odoo Manufacturing (MRP) with Bill of Materials (BOM), work center configuration, and demand forecasting. Automated reorder points and integrated quality control checks.",
    result: "On-time delivery improved to 95%, production delays reduced by 45%, material waste decreased by 30%, and production planning time cut by 70%.",
    requirements: [
      "Odoo MRP configuration",
      "Bill of Materials (BOM) creation",
      "Work center & routing setup",
      "Demand forecasting automation",
      "Quality control integration",
      "Production team training"
    ],
    outcomes: [
      "On-time delivery improved to 95%",
      "45% reduction in production delays",
      "30% decrease in material waste",
      "70% faster production planning",
      "Better resource utilization",
      "Real-time production visibility"
    ],
    client: "Manufacturing Company",
    service: "Odoo Manufacturing (MRP)",
    date: "05-08-2024",
    location: "Ahmedabad, India"
  },

  { 
    id: 4, 
    category: "cat2", 
    img: cImg4, 
    title: "React Native Mobile App UI/UX", 
    slug: "react-native-ui",
    mainTitle: "Designing intuitive mobile apps for field operations",
    challenge: "A sales organization needed mobile access to CRM, inventory, and customer data while in the field. Legacy web systems were not mobile-friendly and required internet connectivity.",
    approach: "We designed and developed a React Native app with offline capabilities, real-time sync with Odoo backend, push notifications, and an intuitive mobile-first interface.",
    result: "Sales team productivity increased by 45%, customer response time improved by 60%, field data accuracy reached 99%, and app adoption rate was 98%.",
    requirements: [
      "React Native cross-platform development",
      "Offline-first architecture",
      "Odoo API integration",
      "Push notifications setup",
      "Secure authentication",
      "iOS & Android optimization"
    ],
    outcomes: [
      "45% increase in sales productivity",
      "60% faster customer response time",
      "99% field data accuracy",
      "98% user adoption rate",
      "Native performance on both platforms",
      "Easy update deployment"
    ],
    client: "Sales Organization",
    service: "React Native App Development",
    date: "12-07-2024",
    location: "Hyderabad, India"
  },

  { 
    id: 5, 
    category: "cat1", 
    img: cImg5, 
    title: "Custom Odoo Module Development", 
    slug: "odoo-custom-module",
    mainTitle: "Building industry-specific custom Odoo modules",
    challenge: "An enterprise had unique business workflows that standard Odoo modules couldn't handle. They needed custom functionality for their specific supply chain and quality management processes.",
    approach: "Our development team designed and built custom Odoo modules with business-specific logic, integrated with existing Odoo modules, and ensured seamless data flow and reporting.",
    result: "Custom workflows fully automated, business processes streamlined, system ROI achieved in 3.5 months, and 100% uptime maintained throughout implementation.",
    requirements: [
      "Custom module development",
      "Business logic implementation",
      "API customization",
      "Data migration from legacy systems",
      "Integration testing",
      "Documentation & training"
    ],
    outcomes: [
      "Custom workflows fully operational",
      "Business processes 90% automated",
      "100% system uptime achieved",
      "3.5-month ROI realization",
      "Maintainable & scalable code",
      "Future-ready architecture"
    ],
    client: "Enterprise Organization",
    service: "Custom Odoo Module Development",
    date: "30-06-2024",
    location: "Delhi, India"
  },

  { 
    id: 6, 
    category: "cat5", 
    img: cImg6, 
    title: "Odoo Server Deployment & Security", 
    slug: "odoo-security",
    mainTitle: "Enterprise-grade Odoo deployment with security hardening",
    challenge: "An enterprise needed secure, highly available Odoo hosting with compliance requirements (ISO 27001, GDPR). They required automated backups, disaster recovery, and 24/7 monitoring.",
    approach: "We deployed Odoo on a dedicated cloud infrastructure with SSL/TLS encryption, firewall configuration, automated daily backups, disaster recovery plan, and 24/7 monitoring with alerting.",
    result: "99.95% uptime achieved, zero security breaches, automated backup & recovery system in place, and full compliance with ISO 27001 and GDPR standards.",
    requirements: [
      "Cloud infrastructure setup (AWS/Azure)",
      "SSL/TLS certificate installation",
      "Database encryption",
      "Firewall & security groups",
      "Automated backup system",
      "24/7 monitoring & alerts"
    ],
    outcomes: [
      "99.95% uptime guaranteed",
      "Zero security breaches recorded",
      "Automated daily backups",
      "Complete disaster recovery plan",
      "ISO 27001 compliance achieved",
      "GDPR standards met"
    ],
    client: "Enterprise Organization",
    service: "Odoo Server & Security",
    date: "18-05-2024",
    location: "Pune, India"
  },

  { 
    id: 7, 
    category: "cat2", 
    img: cImg7, 
    title: "Brand Identity for E-commerce Client", 
    slug: "ecommerce-branding",
    mainTitle: "Creating cohesive brand identity for e-commerce success",
    challenge: "A new e-commerce startup had inconsistent branding across channels with no clear market positioning. They needed a professional, unified brand identity to compete in a crowded marketplace.",
    approach: "We designed a comprehensive brand identity including logo, color palette, typography, brand guidelines, and applied it consistently across web, mobile, and marketing materials.",
    result: "Brand recognition increased, customer trust improved significantly, and conversion rates increased by 28% within 3 months of rebranding.",
    requirements: [
      "Logo design & variations",
      "Color palette development",
      "Typography selection",
      "Brand guidelines documentation",
      "Web & app branding",
      "Marketing collateral design"
    ],
    outcomes: [
      "Unique, memorable brand identity",
      "28% increase in conversion rates",
      "Improved customer trust",
      "Consistent brand presence",
      "Professional market positioning",
      "Scalable brand system"
    ],
    client: "E-commerce Startup",
    service: "Brand Identity & Design",
    date: "24-04-2024",
    location: "Gurgaon, India"
  },

  { 
    id: 8, 
    category: "cat1", 
    img: cImg8, 
    title: "Magento API Integration & Automation", 
    slug: "magento-integration",
    mainTitle: "Automating Magento operations with Odoo backend",
    challenge: "A Magento e-commerce store had manual order processing taking 2 hours per order, inventory mismatches of 15%, and slow fulfillment. No integration between Magento and warehouse systems.",
    approach: "We configured Magento's GraphQL APIs, integrated with Odoo ERP backend, and automated the entire order-to-fulfillment workflow with real-time inventory updates.",
    result: "Order processing automated by 90%, fulfillment time reduced from 2 days to 4 hours, inventory accuracy improved to 99.5%, and customer satisfaction increased.",
    requirements: [
      "Magento GraphQL API setup",
      "Odoo API integration",
      "Workflow automation",
      "Real-time inventory sync",
      "Order management system",
      "Performance optimization"
    ],
    outcomes: [
      "90% automation of order processing",
      "Fulfillment time from 2 days to 4 hrs",
      "99.5% inventory accuracy",
      "95% reduction in manual errors",
      "Multi-channel selling enabled",
      "Scalable automation system"
    ],
    client: "Magento E-commerce Seller",
    service: "Magento + Odoo Integration",
    date: "10-03-2024",
    location: "Chennai, India"
  },

  { 
    id: 9, 
    category: "cat5", 
    img: cImg9, 
    title: "ERP Workflow Strategy & Optimization", 
    slug: "erp-strategy",
    mainTitle: "Designing optimal ERP workflows for business growth",
    challenge: "A growing business with 3x revenue growth faced operational bottlenecks and inefficiencies. Their existing ERP workflows couldn't handle increased volume without significant cost increase.",
    approach: "We conducted comprehensive business process audit, redesigned workflows for efficiency, implemented automation, and trained teams on optimized processes.",
    result: "Achieved 3x operational scaling without proportional cost increase, efficiency improved by 50%, process bottlenecks reduced by 75%, and compliance maintained throughout.",
    requirements: [
      "Business process audit",
      "Workflow design & optimization",
      "System configuration",
      "Automation setup",
      "Staff training",
      "Performance monitoring"
    ],
    outcomes: [
      "3x operational scaling achieved",
      "50% efficiency improvement",
      "75% reduction in bottlenecks",
      "Compliance standards maintained",
      "Cost optimization realized",
      "Future-ready infrastructure"
    ],
    client: "Growing Enterprise",
    service: "ERP Strategy & Optimization",
    date: "28-02-2024",
    location: "Bangalore, India"
  },

  { 
    id: 10, 
    category: "cat4", 
    img: cImg10, 
    title: "UI Design for Odoo React Admin Panel", 
    slug: "odoo-react-admin",
    mainTitle: "Building a modern admin interface for Odoo",
    challenge: "Odoo's default interface was complex and not user-friendly for the client's team. They needed a modern, intuitive admin panel to simplify daily operations and reduce learning curve.",
    approach: "We designed and developed a custom React-based admin dashboard with real-time data visualization, advanced filtering, responsive design, and optimized performance.",
    result: "User adoption reached 98%, average task completion time reduced by 40%, user satisfaction score improved to 4.8/5, and support ticket volume decreased by 65%.",
    requirements: [
      "React component library design",
      "API integration & data fetching",
      "Real-time dashboards",
      "Advanced filtering & search",
      "Responsive mobile design",
      "Performance optimization"
    ],
    outcomes: [
      "98% user adoption rate",
      "40% reduction in task completion time",
      "4.8/5 user satisfaction score",
      "65% fewer support tickets",
      "Modern, intuitive interface",
      "Easily maintainable codebase"
    ],
    client: "Enterprise Organization",
    service: "UI/UX Design & Development",
    date: "14-01-2024",
    location: "Mumbai, India"
  },
];

export default caseStudies;
